import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';

export const generalSettingPermissions = {
  'general-setting-notifications-module-visible': {
    permissionId: 5,
    appId: 1,
    moduleId: 71,
    featureId: null,
    key: 'general-setting-notifications-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'general-setting-notifications-visible': {
    permissionId: 5,
    appId: 1,
    moduleId: 71,
    featureId: 205,
    key: 'general-setting-notifications-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'general-setting-notifications-create': {
    permissionId: 1,
    appId: 1,
    moduleId: 71,
    featureId: 205,
    key: 'general-setting-notifications-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'general-setting-notifications-read': {
    permissionId: 4,
    appId: 1,
    moduleId: 71,
    featureId: 205,
    key: 'general-setting-notifications-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'general-setting-notifications-edit': {
    permissionId: 2,
    appId: 1,
    moduleId: 71,
    featureId: 205,
    key: 'general-setting-notifications-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'general-setting-notifications-delete': {
    permissionId: 3,
    appId: 1,
    moduleId: 71,
    featureId: 205,
    key: 'general-setting-notifications-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const defaultGeneralSettingPermissions = [
  generalSettingPermissions['general-setting-notifications-visible'],
  generalSettingPermissions['general-setting-notifications-create'],
  generalSettingPermissions['general-setting-notifications-edit'],
  generalSettingPermissions['general-setting-notifications-read'],
  generalSettingPermissions['general-setting-notifications-delete'],
];
